// © Microsoft Corporation. All rights reserved.

/**
 * An enumeration indicating the MSA sign in status for the page.
 */
export enum SignedInStatus {
    Unknown,
    NotSignedIn,
    SignedIn
}

/**
 * The various account types that we support in Peregrine, this enum can be modified as new types are added
 * "MSA" - MSA
 * "AAD" - AAD
 */
export enum AccountType {
    MSA = "MSA",
    AAD = "AAD"
}

/**
 * Note: these values are used by the Telemetry team and must remain in the following order:
 * 0 - NonAadAccount
 * 1 - AadAccount
 * 2 - Unknown
 */
export enum AadAccountType {
    NonAadAccount = 0,
    AadAccount = 1,
    Unknown = 2
}